import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function Login() {
  const navigate = useNavigate();
  const [user_id, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await api.post(
        "/auth/login",
        { user_id, password },
        { withCredentials: false } // ✅ ensure CORS doesn’t block
      );

      if (res.data?.token && res.data?.user) {
        // ✅ Store all essentials in localStorage
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("userRole", res.data.user.role);

        console.log("✅ Login success:", res.data.user);

        // ✅ Redirect to dashboard
        navigate("/dashboard");
      } else {
        setError("Invalid response from server");
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      const msg =
        err.response?.data?.error ||
        (err.message?.includes("Network") ? "Cannot reach server" : "Invalid credentials");
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-screen h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-gray-100 overflow-hidden">
      {/* Sidebar Branding */}
      <div className="hidden md:flex absolute left-0 top-0 h-full w-1/3 bg-gradient-to-b from-orange-500 via-orange-400 to-orange-200 items-center justify-center">
        <h1 className="text-6xl font-extrabold text-white tracking-wide drop-shadow-2xl">
          Core60
        </h1>
      </div>

      {/* Login Box */}
      <div className="relative z-10 flex items-center justify-center w-full px-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 space-y-6 border border-orange-100">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-orange-500">
              Core60 Control Panel
            </h1>
            <p className="text-gray-500 mt-2">Sign in to your admin account</p>
          </div>

          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label className="block text-gray-700 font-medium mb-1">User ID</label>
              <input
                type="text"
                placeholder="Enter your ID"
                value={user_id}
                onChange={(e) => setUserId(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`w-full text-white font-semibold py-2 rounded-lg shadow-md transition duration-200 ${
                loading
                  ? "bg-orange-300 cursor-not-allowed"
                  : "bg-orange-500 hover:bg-orange-600"
              }`}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p className="text-center text-gray-500 text-sm mt-6">
            © {new Date().getFullYear()} Core60. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
